import { makeSearchParamsString } from "../../main/functions/make-search-params-string.js";
import env from "../../root/env.js";
import { userInteractions } from "../../root/modules/telemetry/data/user-interactions.js";
import { postMessage } from "./post-message.js";

export const openOnDashboard = ({
  alertID,
  browserCommand,
  caseID,
  caseNumber,
  closeWindow = true,
  event,
}) => {
  postMessage({
    message: {
      args: [
        {
          data: {
            alertID,
            caseID,
            caseNumber,
          },
          type: userInteractions.showCaseDetails,
        },
      ],
      request: "trackLastUserInteraction",
    },
  });

  postMessage({
    message: {
      args: [
        "Alert window 'Show Details' button clicked.",
        { alertID, caseID, caseNumber },
      ],
      context: "USER_INTERACTION",
      level: "info",
      request: "log",
    },
  });

  if (window.api) {
    event?.preventDefault();

    let dashboardURL = env.VITE_DASHBOARD_URL;

    const ssoProvider = localStorage.getItem("ssoProvider");
    const ssoSubdomain = localStorage.getItem("ssoSubdomain");

    if (ssoSubdomain) {
      dashboardURL = dashboardURL.replace(/ondeck|demo|live/, ssoSubdomain);
    }

    let url = `${dashboardURL}/cases/${caseID}`;

    if (ssoProvider) {
      url += `?${makeSearchParamsString({
        searchParams: { ssoProvider },
      })}`;
    }

    const openExternalURLParameter = {
      browserCommand,
      url,
    };

    window.api.openExternalURL?.(openExternalURLParameter);

    // this old code to be removed
    // it was (is?) used by an older version of the desktop application
    // we need to check and then(?) remove it
    window.api.openExternalUrl?.(openExternalURLParameter);
  }

  if (closeWindow) {
    setTimeout(() => window.close(), 1000);
  }
};
